import styled from "@emotion/styled";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.colors.secondaryColor};
  font-size: 1rem;
`;
